<template>
  <div class="role-list">
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="roles">
      <el-button slot="toolbar" type="primary" size="mini" @click="$refs.editPage.open(0)">新增</el-button>
      <el-button slot="toolbar" type="primary" size="mini" @click="deleteRow(scope.row)">删除</el-button>
      <el-button slot="toolbar" type="primary" size="mini" @click="exportExcel()">导出</el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="所属角色">
            <el-input v-model.trim="filter.roleName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" width="55"/>
      <el-table-column prop="id" label="ID" width="100"/>
      <el-table-column prop="roleName" label="所属角色"/>
      <el-table-column width="150" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <edit-page ref="editPage" @save-success="getList"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EditPage from "./RoleEdit.vue";

  export default {
    name: "RoleList",
    components: {VmTable, EditPage, VmSearch},
    data() {
      return {
        filter: {
          roleName: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList() {
        this.$refs.vmTable.getList();
      },
      handleDelete(row) {
        this.$confirm(`确定删除${row.roleName}吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "roles", row.id).then(() => {
            this.getList();
            this.$message.success("删除成功");
          });
        });
      },

      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","roles/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .role-list {
    .permissionLabel {
      display: inline-block;
      border-radius: 2px;
      background-color: #fafafa;
      border: 1px solid #E4E7ED;
      color: #666;
      padding: 0 7px;
      margin: 2px;
      font-size: 11px;
    }
  }
</style>
